import { Button, Input, Modal, ModalProps } from 'antd';
import { ChangeEvent, useEffect, useState } from 'react';
import { useMemoizedFn } from 'ahooks';
import { useTranslate } from '@tolgee/react';

interface CaptchaImageModalProps extends ModalProps {
  imgSrc?: string;
  loading?: boolean;
  onConfirm: (value: string) => void;
  onCancel: () => void;
  onChangeImage: () => void;
}

export const CaptchaImageModal = (props: CaptchaImageModalProps) => {
  const { t } = useTranslate();
  const { imgSrc, loading, onConfirm, onChangeImage, onCancel, ...rest } = props;
  const [captchaImageValue, setCaptchaImageValue] = useState('');

  const handleChange = useMemoizedFn((e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCaptchaImageValue(value);
  });

  const handleOk = useMemoizedFn(() => {
    onConfirm(captchaImageValue);
  });

  const handleCancel = useMemoizedFn(() => {
    setCaptchaImageValue('');
    onCancel();
  });

  useEffect(() => {
    setCaptchaImageValue('');
  }, [imgSrc]);

  return (
    <Modal
      {...rest}
      title={t('输入图形验证码获取短信')}
      width={400}
      okButtonProps={{
        loading,
        disabled: !captchaImageValue,
      }}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Input.Group compact>
        <Input
          placeholder={t('输入图形验证码获取短信')}
          className="!w-1/2"
          value={captchaImageValue}
          onChange={handleChange}
        />
        <div className="w-1/2 !inline-flex items-center">
          <div className="flex-1">
            <img className="w-full" src={imgSrc} alt="Captcha" />
          </div>
          <Button size="small" type="link" onClick={onChangeImage}>
            {t('换一个')}
          </Button>
        </div>
      </Input.Group>
    </Modal>
  );
};
